import { Language } from '@eneco/common/application';

export const COUNTRIES_MAP = [
  { value: 'BE', label: { nl: 'België', fr: 'Belgique', en: 'Belgium' } },
  { value: 'NL', label: { nl: 'Nederland', fr: 'Pays-Bas', en: 'Netherlands' } },
  { value: 'LU', label: { nl: 'Luxemburg', fr: 'Luxembourg', en: 'Luxembourg' } },
  { value: 'FR', label: { nl: 'Frankrijk', fr: 'France', en: 'France' } },
  { value: 'DE', label: { nl: 'Duitsland', fr: 'Allemagne', en: 'Germany' } },
  { value: 'AT', label: { nl: 'Oostenrijk', fr: 'Autriche', en: 'Austria' } },
  { value: 'BG', label: { nl: 'Bulgarije', fr: 'Bulgarie', en: 'Bulgaria' } },
  { value: 'HR', label: { nl: 'Kroatië', fr: 'Croatie', en: 'Croatia' } },
  { value: 'CY', label: { nl: 'Cyprus', fr: 'Chypre', en: 'Cyprus' } },
  { value: 'CZ', label: { nl: 'Tsjechië', fr: 'Tchéquie', en: 'Czech Republic' } },
  { value: 'DK', label: { nl: 'Denemarken', fr: 'Danemark', en: 'Denmark' } },
  { value: 'EE', label: { nl: 'Estland', fr: 'Estonie', en: 'Estonia' } },
  { value: 'FI', label: { nl: 'Finland', fr: 'Finlande', en: 'Finland' } },
  { value: 'GF', label: { nl: 'Frans Guiana', fr: 'Guyane française', en: 'French Guiana' } },
  { value: 'GI', label: { nl: 'Gibraltar', fr: 'Gibraltar', en: 'Gibraltar' } },
  { value: 'GR', label: { nl: 'Griekenland', fr: 'Grèce', en: 'Greece' } },
  { value: 'GP', label: { nl: 'Guadaloupe', fr: 'Guadeloupe', en: 'Guadeloupe' } },
  { value: 'HU', label: { nl: 'Hongarije', fr: 'Hongrie', en: 'Hungary' } },
  { value: 'IS', label: { nl: 'Ijsland', fr: 'Islande', en: 'Iceland' } },
  { value: 'IE', label: { nl: 'Ierland', fr: 'Irlande', en: 'Ireland' } },
  { value: 'IT', label: { nl: 'Italië', fr: 'Italie', en: 'Italy' } },
  { value: 'LV', label: { nl: 'Letland', fr: 'Lettonie', en: 'Latvia' } },
  { value: 'LI', label: { nl: 'Liechtenstein', fr: 'Liechtenstein', en: 'Liechtenstein' } },
  { value: 'LT', label: { nl: 'Litouwen', fr: 'Lituanie', en: 'Lithuania' } },
  { value: 'MT', label: { nl: 'Malta', fr: 'Malte', en: 'Malta' } },
  { value: 'MQ', label: { nl: 'Martinique', fr: 'Martinique', en: 'Martinique' } },
  { value: 'YT', label: { nl: 'Mayotte', fr: 'Mayotte', en: 'Mayotte' } },
  { value: 'MC', label: { nl: 'Monaco', fr: 'Monaco', en: 'Monaco' } },
  { value: 'NO', label: { nl: 'Noorwegen', fr: 'Norvège', en: 'Norway' } },
  { value: 'PL', label: { nl: 'Polen', fr: 'Pologne', en: 'Poland' } },
  { value: 'PT', label: { nl: 'Portugal', fr: 'Portugal', en: 'Portugal' } },
  { value: 'RE', label: { nl: 'Réunion', fr: 'La Réunion', en: 'Reunion' } },
  { value: 'RO', label: { nl: 'Roemenië', fr: 'Roumanie', en: 'Romania' } },
  { value: 'BL', label: { nl: 'Sint Barthélemy', fr: 'Saint-Barthélemy', en: 'Saint Barthélemy' } },
  { value: 'MF', label: { nl: 'Sint Martin (Frans)', fr: 'Saint-Martin (France)', en: 'Saint Martin (France)' } },
  {
    value: 'PM',
    label: { nl: 'Saint Pierre and Miquelon', fr: 'Saint-Pierre-et-Miquelon', en: 'Saint Pierre and Miquelon' },
  },
  { value: 'SK', label: { nl: 'Slovakije', fr: 'Slovaquie', en: 'Slovakia' } },
  { value: 'SI', label: { nl: 'Slovenië', fr: 'Slovénie', en: 'Slovenia' } },
  { value: 'ES', label: { nl: 'Spanje', fr: 'Espagne', en: 'Spain' } },
  { value: 'SE', label: { nl: 'Zweden', fr: 'Suède', en: 'Sweden' } },
  { value: 'CH', label: { nl: 'Zwitserland', fr: 'Suisse', en: 'Switzerland' } },
  { value: 'GB', label: { nl: 'Verenigd Koningkrijk', fr: 'Royaume-Uni', en: 'United Kingdom' } },
];

export const getCountryOptions = (language: Language) => {
  return COUNTRIES_MAP.map(c => ({ value: c.value, label: c.label[language] }));
};
